module.exports = __webpack_public_path__ + "static/media/staffimg1.c80474fd.png";